import { useApplications } from "./useApplications";
import { usePrevious } from "./usePrevious";
import { useUser } from "./useUser";
import { useUserID } from "./useUserID";
import { useDirectory } from "./useDirectory";
import { useEmployeeByEmail } from "./useEmployeeByEmail";
import { useEnvironments } from "./useEnvironments";
import { useRoles } from "./useRoles";
import { useInfrastructureApplications } from "./useInfrastructureApplications";
import { useSettings } from "./useSettings";
import { useQueryParam } from "./useQueryParam";
import { useBusinessTypeSelect } from "./useBusinessTypeSelect";
import { useSystemCategorySelect } from "./useSystemCategorySelect";
import { useApproverDistroSelect } from "./useApproverDistroSelect";
import { useSystemAppNameSelect } from "./useSystemAppNameSelect";
import { useInfrastructureSelect } from "./useInfrastructureSelect";
import { useLandingZoneRoles } from "./useLandingZoneRoles";
import { useSalesforceFormSelect } from "./useSalesforceFormSelect";

export { useUserApi } from "./useGoogleApi";

const Hooks = {
  useApplications,
  usePrevious,
  useUser,
  useUserID,
  useDirectory,
  useEmployeeByEmail,
  useEnvironments,
  useRoles,
  useInfrastructureApplications,
  useSettings,
  useQueryParam,
  useBusinessTypeSelect,
  useSystemCategorySelect,
  useApproverDistroSelect,
  useSystemAppNameSelect,
  useInfrastructureSelect,
  useLandingZoneRoles,
  useSalesforceFormSelect,
};

export {
  Hooks,
  useApplications,
  usePrevious,
  useUser,
  useUserID,
  useDirectory,
  useEmployeeByEmail,
  useEnvironments,
  useRoles,
  useInfrastructureApplications,
  useSettings,
  useQueryParam,
  useBusinessTypeSelect,
  useSystemCategorySelect,
  useApproverDistroSelect,
  useSystemAppNameSelect,
  useInfrastructureSelect,
  useLandingZoneRoles,
  useSalesforceFormSelect,
};

export default Hooks;
